import React, { useCallback, useState } from 'react';
import { Button, Dialog } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';
import type { OdinUser } from '../../../@types/users';
import ChangePasswordModal from '../../layout/components/change-password-modal.component';

interface UserSettingsModalProps {
  onClose: () => void;
  userData: OdinUser | undefined;
  visible: boolean;
}

export default function UserSettingsModal({ onClose, userData, visible }: UserSettingsModalProps) {
  const { t } = useTranslation();
  const [showChangePassword, setShowChangePassword] = useState(false);

  const onChangePasswordClick = useCallback(() => {
    onClose();
    setShowChangePassword(true);
  }, [onClose]);

  const onCloseCallback = useCallback(() => {
    setShowChangePassword(false);
  }, []);

  return (
    <>
      <Dialog
        header={t('settings')}
        visible={Boolean(visible)}
        onClose={onClose}
        containerClassName="sm:min-w-[300px]"
        contentClassName="p-2 space-y-4"
      >
        <div className="space-y-4">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className={'odin-block odin-text-sm odin-font-bold'}>{t('first-name')}</label>
              <span> {userData?.firstName}</span>
            </div>
            <div>
              <label className="odin-block odin-text-sm odin-font-bold">{t('last-name')}</label>
              <span>{userData?.lastName}</span>
            </div>
            <div className="odin-overflow-x-auto">
              <label className="odin-block odin-text-sm odin-font-bold">{t('email')}</label>
              <span className="odin-inline-block">{userData?.email}</span>
            </div>
            <Button type="primary" variant="alternative" onClick={onChangePasswordClick}>
              {t('reset-password')}
            </Button>
          </div>
        </div>
      </Dialog>
      {showChangePassword && (
        <ChangePasswordModal visible={showChangePassword} onCloseCallback={onCloseCallback} isUserSettingsModal />
      )}
    </>
  );
}
